import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function Updates2026Article() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-2026-updates"]} />;
}